import { gql } from 'apollo-angular';
import { EditTacticFragment } from '@modules/tactics/shared/graphql/fragments/edit-tactic.fragment';

export const FullTacticFragment = gql`
  fragment FullTactic on TacticOutputGraphql {
    ...EditTactic
    myRate {
      rate
    }
  }
  ${EditTacticFragment}
`;
